import { Th, Td } from 'xpi-black-ui/Common/Table';
import Bullet from 'xpi-black-ui/Base/Bullet';
import Tooltip from 'xpi-black-ui/Base/Tooltip';
import styled, { css } from 'styled-components';

const COLOR_BULLET = {
  WaitingPrice: '#3597DB',
  WaitingApprovalConfirmation: '#3597DB',
  ReadyForExecution: '#3597DB',
  PendingExecution: '#3597DB',
  PostExecutionCheck: '#3597DB',
  PendingRegistration: '#3597DB',
  Active: '#02DB18',
  Quoted: '#02DB18',
  PreQuoted: '#FFC709',
  Requested: '#FFC709',
  SentToClient: '#FFC709',
  Accepted: '#FFC709',
  Registered:'#FFC709',
  Complete: '#02DB18',
  Canceled: '#FF0026',
  Unavailable: '#FF0026'
};

const WrapperActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export default WrapperActions;

export const CustomTh = styled(Th)`
  ${({ isSticky }) => isSticky && css`
    position: sticky;
    left: -16px;
    background-color: #34343a;
  `};
`;

export const CustomTd = styled(Td)`
  ${({ isSticky }) => isSticky && css`
    position: sticky;
    left: -16px;

    &:nth-child(odd) {
      background-color: #3f4147;
    }
  `};
`;

export const CustomTooltip = styled(Tooltip)`
  border-bottom: none;

  ::before {
    left: 30% !important;
    max-width: 320px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  ${({ addBorder }) => addBorder && css`
    border-bottom: dashed 1px #838383;
  `};
`;

export const StatusBullet = styled(Bullet).attrs(({ name }) => ({ color: COLOR_BULLET[name] || '#47494e' }))``;
